import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["csvRecordLine"];

  connect() {
    this._subscribeToHandleSalesCsvChannel();
  }

  _subscribeToHandleSalesCsvChannel() {
    App.cable.subscriptions.create(
      { channel: "CsvFileImportChannel", stream_name: "sales_csv_import_done" },
      {
        received: (data) => {
          const csvImportLine = this.csvRecordLineTargets.find(
            (line) => line.dataset.csvImportId === data.id.toString()
          );
          csvImportLine.querySelector(".status").innerText = csvImportLine.dataset.importedLabel;
        },
      }
    );
  }
}
